import { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

/**
 * Tooltip with Show and Hide delays.
 */
const useTooltip = ({ showDelay = 600, hideDelay = 600 }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const showTimer = useRef(null);
  const hideTimer = useRef(null);

  const insideLinger = 300; // millis to linger the active tooltip while inside the component.


  // ---[  Clear Timers  ]---
  //
  const clearTimers = () => {
    if (showTimer.current) {
      clearTimeout(showTimer.current);
      showTimer.current = null;
    }
    if (hideTimer.current) {
      clearTimeout(hideTimer.current);
      hideTimer.current = null;
    }
  }

  // ---[  Handle Mouse Enter and Leave Events  ]---
  //
  const handleMouseEnter = () => {
    clearTimers();
    showTimer.current = setTimeout(() => setShowTooltip(true), showDelay);
    // Remove the tooltip on time even if the mouse stays inside.
    hideTimer.current = setTimeout(() => setShowTooltip(false), showDelay+hideDelay+insideLinger);
  };

  const handleMouseLeave = () => {
    clearTimers();
    hideTimer.current = setTimeout(() => setShowTooltip(false), hideDelay);
  };

  // ---[  Handle Focus and Blur Events  ]---
  //
  const handleFocus = () => handleMouseEnter();
  const handleBlur = () => handleMouseLeave();

  // ---[  Cleanup Timers on Unmount  ]---
  //
  useEffect(() => {
    return () => {
      if (showTimer.current) clearTimeout(showTimer.current);
      if (hideTimer.current) clearTimeout(hideTimer.current);
    };
  }, []);


  // ---  Return  ---
  //
  return {
    showTooltip,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onFocus: handleFocus,
    onBlur: handleBlur,
  };
};

// --- PropTypes ---
//
useTooltip.propTypes = {
  showDelay: PropTypes.number,
  hideDelay: PropTypes.number,
};


export default useTooltip;